module.exports = __webpack_public_path__ + "img/logo-pulmonology.f1ab2aac.png";